import { render } from "./Header.vue?vue&type=template&id=668217b2"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/styles/header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__